export const getCriteria = `
  query getCriteria {
    getCriteria {
      defaults {
        programId
        reviewType
        label
      }
    rules {
      programId
      reviewType
      label
      expressions {
        reviewType
        expressionSetIndex
        expressionCriteria
        operator
        value {
          type
          value
        }
      }
    }
}
}`

export const saveCriteria = `
 mutation saveCriteria($rules: AWSJSON!) {
    saveCriteria(rules: $rules) {
      status
  }
}`